DR.services = DR.services || {};
DR.services.struct = DR.services.struct || {};
DR.services.select = DR.services.select || {};
/** @extends {DR._Base} */
DR.services.struct.PaymentInfoErrors = function(par){
	/** @private */
	this._t = 1137;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.address)) this.address = String(par.address||'');
	if(DR._Base.is(par.city)) this.city = String(par.city||'');
	if(DR._Base.is(par.country)) this.country = String(par.country||'');
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
	if(DR._Base.is(par.phone)) this.phone = String(par.phone||'');
	if(DR._Base.is(par.phoneCode)) this.phoneCode = String(par.phoneCode||'');
	if(DR._Base.is(par.registrationNumber)) this.registrationNumber = String(par.registrationNumber||'');
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
	if(DR._Base.is(par.vatNumber)) this.vatNumber = String(par.vatNumber||'');
};
DR._Base._types[1137] = DR.services.struct.PaymentInfoErrors;
DR.services.struct.PaymentInfoErrors[__P] = new DR._Base;
DR.services.struct.PaymentInfoErrors[__P][__C] = DR.services.struct.PaymentInfoErrors;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.address = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.city = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.country = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.name = null;
/** @type {Boolean} */
DR.services.struct.PaymentInfoErrors.prototype.ok = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.phone = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.phoneCode = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.registrationNumber = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.type = null;
/** @type {String|null} */
DR.services.struct.PaymentInfoErrors.prototype.vatNumber = null;

/** @extends {DR._Base} */
DR.services.struct.EveryPayPaymentMethod = function(par){
	/** @private */
	this._t = 1386;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.link)) this.link = String(par.link||'');
	if(DR._Base.is(par.logoLink)) this.logoLink = String(par.logoLink||'');
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
	if(DR._Base.is(par.source)) this.source = String(par.source||'');
};
DR._Base._types[1386] = DR.services.struct.EveryPayPaymentMethod;
DR.services.struct.EveryPayPaymentMethod[__P] = new DR._Base;
DR.services.struct.EveryPayPaymentMethod[__P][__C] = DR.services.struct.EveryPayPaymentMethod;
/** @type {String|null} */
DR.services.struct.EveryPayPaymentMethod.prototype.link = null;
/** @type {String} */
DR.services.struct.EveryPayPaymentMethod.prototype.logoLink = null;
/** @type {String} */
DR.services.struct.EveryPayPaymentMethod.prototype.name = null;
/** @type {String} */
DR.services.struct.EveryPayPaymentMethod.prototype.source = null;

/** @extends {DR._Base} */
DR.services.struct.PurchaseTicketErrors = function(par){
	/** @private */
	this._t = 1141;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.discountCode)) this.discountCode = String(par.discountCode||'');
	if(DR._Base.is(par.donation)) this.donation = (parseInt(par.donation)||0);
	if(DR._Base.is(par.inviteEmails)){
		var tmp = {};
		for( var k in par.inviteEmails ) tmp[k] = String(par.inviteEmails [k]||'');
		this.inviteEmails = tmp;
	}
	if(DR._Base.is(par.paymentInfo)) this.paymentInfo = DR._Base.cast(par.paymentInfo);
	if(DR._Base.is(par.playerCount)) this.playerCount = String(par.playerCount||'');
	if(DR._Base.is(par.teamCount)) this.teamCount = String(par.teamCount||'');
	if(DR._Base.is(par.teamTitle)) this.teamTitle = String(par.teamTitle||'');
};
DR._Base._types[1141] = DR.services.struct.PurchaseTicketErrors;
DR.services.struct.PurchaseTicketErrors[__P] = new DR._Base;
DR.services.struct.PurchaseTicketErrors[__P][__C] = DR.services.struct.PurchaseTicketErrors;
/** @type {String|null} */
DR.services.struct.PurchaseTicketErrors.prototype.discountCode = null;
/** @type {Number|null} */
DR.services.struct.PurchaseTicketErrors.prototype.donation = null;
/** @type {Object.<Number,String>|null} */
DR.services.struct.PurchaseTicketErrors.prototype.inviteEmails = null;
/** @type {DR.services.struct.PaymentInfoErrors|null} */
DR.services.struct.PurchaseTicketErrors.prototype.paymentInfo = null;
/** @type {String|null} */
DR.services.struct.PurchaseTicketErrors.prototype.playerCount = null;
/** @type {String|null} */
DR.services.struct.PurchaseTicketErrors.prototype.teamCount = null;
/** @type {String|null} */
DR.services.struct.PurchaseTicketErrors.prototype.teamTitle = null;

/** @extends {DR._Base} */
DR.services.struct.EveryPayPaymentMethodsCountry = function(par){
	/** @private */
	this._t = 1387;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.country)) this.country = String(par.country||'');
	if(DR._Base.is(par.paymentMethods)){
		var tmp = [];
		for( var k in par.paymentMethods ) tmp.push(DR._Base.cast(par.paymentMethods [k]));
		this.paymentMethods = tmp;
	}
};
DR._Base._types[1387] = DR.services.struct.EveryPayPaymentMethodsCountry;
DR.services.struct.EveryPayPaymentMethodsCountry[__P] = new DR._Base;
DR.services.struct.EveryPayPaymentMethodsCountry[__P][__C] = DR.services.struct.EveryPayPaymentMethodsCountry;
/** @type {String} */
DR.services.struct.EveryPayPaymentMethodsCountry.prototype.country = null;
/** @type {Array.<DR.services.struct.EveryPayPaymentMethod>} */
DR.services.struct.EveryPayPaymentMethodsCountry.prototype.paymentMethods = null;

/** @extends {DR._Base} */
DR.services.struct.HintPackage = function(par){
	/** @private */
	this._t = 1248;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.count)) this.count = (parseInt(par.count)||0);
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
};
DR._Base._types[1248] = DR.services.struct.HintPackage;
DR.services.struct.HintPackage[__P] = new DR._Base;
DR.services.struct.HintPackage[__P][__C] = DR.services.struct.HintPackage;
/** @type {Number} */
DR.services.struct.HintPackage.prototype.count = null;
/** @type {Number} */
DR.services.struct.HintPackage.prototype.price = null;

/** @extends {DR._Base} */
DR.services.struct.OmnivaLocation = function(par){
	/** @private */
	this._t = 1147;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.address)) this.address = String(par.address||'');
	if(DR._Base.is(par.city)) this.city = String(par.city||'');
	if(DR._Base.is(par.country)) this.country = String(par.country||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
};
DR._Base._types[1147] = DR.services.struct.OmnivaLocation;
DR.services.struct.OmnivaLocation[__P] = new DR._Base;
DR.services.struct.OmnivaLocation[__P][__C] = DR.services.struct.OmnivaLocation;
/** @type {String} */
DR.services.struct.OmnivaLocation.prototype.address = null;
/** @type {String} */
DR.services.struct.OmnivaLocation.prototype.city = null;
/** @type {String} */
DR.services.struct.OmnivaLocation.prototype.country = null;
/** @type {Number} */
DR.services.struct.OmnivaLocation.prototype.id = null;
/** @type {String} */
DR.services.struct.OmnivaLocation.prototype.name = null;

/** @extends {DR._Base} */
DR.services.struct.PickupLocation = function(par){
	/** @private */
	this._t = 1299;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.address)) this.address = String(par.address||'');
	if(DR._Base.is(par.city)) this.city = String(par.city||'');
	if(DR._Base.is(par.country)) this.country = String(par.country||'');
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.title)) this.title = String(par.title||'');
};
DR._Base._types[1299] = DR.services.struct.PickupLocation;
DR.services.struct.PickupLocation[__P] = new DR._Base;
DR.services.struct.PickupLocation[__P][__C] = DR.services.struct.PickupLocation;
/** @type {String} */
DR.services.struct.PickupLocation.prototype.address = null;
/** @type {String} */
DR.services.struct.PickupLocation.prototype.city = null;
/** @type {String} */
DR.services.struct.PickupLocation.prototype.country = null;
/** @type {Number} */
DR.services.struct.PickupLocation.prototype.id = null;
/** @type {String} */
DR.services.struct.PickupLocation.prototype.title = null;

/** @extends {DR._Base} */
DR.services.struct.PaymentInfo = function(par){
	/** @private */
	this._t = 1130;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.address)) this.address = String(par.address||'');
	if(DR._Base.is(par.city)) this.city = String(par.city||'');
	if(DR._Base.is(par.country)) this.country = String(par.country||'');
	if(DR._Base.is(par.name)) this.name = String(par.name||'');
	if(DR._Base.is(par.phone)) this.phone = String(par.phone||'');
	if(DR._Base.is(par.phoneCode)) this.phoneCode = String(par.phoneCode||'');
	if(DR._Base.is(par.registrationNumber)) this.registrationNumber = String(par.registrationNumber||'');
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
	if(DR._Base.is(par.vatNumber)) this.vatNumber = String(par.vatNumber||'');
};
DR._Base._types[1130] = DR.services.struct.PaymentInfo;
DR.services.struct.PaymentInfo.TYPE_PRIVATE = "private";
DR.services.struct.PaymentInfo.TYPE_COMPANY = "company";
DR.services.struct.PaymentInfo[__P] = new DR._Base;
DR.services.struct.PaymentInfo[__P][__C] = DR.services.struct.PaymentInfo;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.address = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.city = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.country = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.name = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.phone = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.phoneCode = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.registrationNumber = null;
/** @type {String} */
DR.services.struct.PaymentInfo.prototype.type = null;
/** @type {String|null} */
DR.services.struct.PaymentInfo.prototype.vatNumber = null;

/** @extends {DR._Base} */
DR.services.struct.CheckDiscountRe = function(par){
	/** @private */
	this._t = 1133;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.amount)) this.amount = (parseInt(par.amount)||0);
	if(DR._Base.is(par.donation)) this.donation = (parseInt(par.donation)||0);
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
	if(DR._Base.is(par.type)) this.type = String(par.type||'');
	if(DR._Base.is(par.validUntil)) this.validUntil = (parseInt(par.validUntil)||0);
};
DR._Base._types[1133] = DR.services.struct.CheckDiscountRe;
DR.services.struct.CheckDiscountRe.TYPE_STATIC = "static";
DR.services.struct.CheckDiscountRe.TYPE_PERCENT = "percent";
DR.services.struct.CheckDiscountRe[__P] = new DR._Base;
DR.services.struct.CheckDiscountRe[__P][__C] = DR.services.struct.CheckDiscountRe;
/** @type {Number|null} */
DR.services.struct.CheckDiscountRe.prototype.amount = null;
/** @type {Number} */
DR.services.struct.CheckDiscountRe.prototype.donation = null;
/** @type {Number} */
DR.services.struct.CheckDiscountRe.prototype.price = null;
/** @type {String|null} */
DR.services.struct.CheckDiscountRe.prototype.type = null;
/** @type {Number|null} */
DR.services.struct.CheckDiscountRe.prototype.validUntil = null;

/** @extends {DR._Base} */
DR.services.struct.PurchaseTicketRe = function(par){
	/** @private */
	this._t = 1132;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.errors)) this.errors = DR._Base.cast(par.errors);
	if(DR._Base.is(par.freePurchase)) this.freePurchase = Boolean(par.freePurchase);
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
	if(DR._Base.is(par.paymentId)) this.paymentId = (parseInt(par.paymentId)||0);
	if(DR._Base.is(par.paymentMethod)) this.paymentMethod = String(par.paymentMethod||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1132] = DR.services.struct.PurchaseTicketRe;
DR.services.struct.PurchaseTicketRe.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.struct.PurchaseTicketRe.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.struct.PurchaseTicketRe[__P] = new DR._Base;
DR.services.struct.PurchaseTicketRe[__P][__C] = DR.services.struct.PurchaseTicketRe;
/** @type {DR.services.struct.PurchaseTicketErrors|null} */
DR.services.struct.PurchaseTicketRe.prototype.errors = null;
/** @type {Boolean} */
DR.services.struct.PurchaseTicketRe.prototype.freePurchase = null;
/** @type {Boolean} */
DR.services.struct.PurchaseTicketRe.prototype.ok = null;
/** @type {Number|null} */
DR.services.struct.PurchaseTicketRe.prototype.paymentId = null;
/** @type {String|null} */
DR.services.struct.PurchaseTicketRe.prototype.paymentMethod = null;
/** @type {String|null} */
DR.services.struct.PurchaseTicketRe.prototype.url = null;

/** @extends {DR._Base} */
DR.services.struct.VATStatus = function(par){
	/** @private */
	this._t = 1292;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.hasVAT)) this.hasVAT = Boolean(par.hasVAT);
};
DR._Base._types[1292] = DR.services.struct.VATStatus;
DR.services.struct.VATStatus[__P] = new DR._Base;
DR.services.struct.VATStatus[__P][__C] = DR.services.struct.VATStatus;
/** @type {Boolean} */
DR.services.struct.VATStatus.prototype.hasVAT = null;

/** @extends {DR._Base} */
DR.services.struct.BraintreeClientToken = function(par){
	/** @private */
	this._t = 1201;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.token)) this.token = String(par.token||'');
};
DR._Base._types[1201] = DR.services.struct.BraintreeClientToken;
DR.services.struct.BraintreeClientToken[__P] = new DR._Base;
DR.services.struct.BraintreeClientToken[__P][__C] = DR.services.struct.BraintreeClientToken;
/** @type {String} */
DR.services.struct.BraintreeClientToken.prototype.token = null;

/** @extends {DR._Base} */
DR.services.struct.EveryPayData = function(par){
	/** @private */
	this._t = 1384;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.accountName)) this.accountName = String(par.accountName||'');
	if(DR._Base.is(par.amount)) this.amount = (parseInt(par.amount)||0);
	if(DR._Base.is(par.apiUsername)) this.apiUsername = String(par.apiUsername||'');
	if(DR._Base.is(par.applePayMerchantIdentifier)) this.applePayMerchantIdentifier = String(par.applePayMerchantIdentifier||'');
	if(DR._Base.is(par.currency)) this.currency = String(par.currency||'');
	if(DR._Base.is(par.descriptorCountry)) this.descriptorCountry = String(par.descriptorCountry||'');
	if(DR._Base.is(par.googlePayMerchantIdentifier)) this.googlePayMerchantIdentifier = String(par.googlePayMerchantIdentifier||'');
	if(DR._Base.is(par.label)) this.label = String(par.label||'');
	if(DR._Base.is(par.mobileToken)) this.mobileToken = String(par.mobileToken||'');
	if(DR._Base.is(par.paymentLink)) this.paymentLink = String(par.paymentLink||'');
	if(DR._Base.is(par.paymentMethods)){
		var tmp = [];
		for( var k in par.paymentMethods ) tmp.push(DR._Base.cast(par.paymentMethods [k]));
		this.paymentMethods = tmp;
	}
	if(DR._Base.is(par.paymentReference)) this.paymentReference = String(par.paymentReference||'');
};
DR._Base._types[1384] = DR.services.struct.EveryPayData;
DR.services.struct.EveryPayData[__P] = new DR._Base;
DR.services.struct.EveryPayData[__P][__C] = DR.services.struct.EveryPayData;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.accountName = null;
/** @type {Number|null} */
DR.services.struct.EveryPayData.prototype.amount = null;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.apiUsername = null;
/** @type {String|null} */
DR.services.struct.EveryPayData.prototype.applePayMerchantIdentifier = null;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.currency = null;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.descriptorCountry = null;
/** @type {String|null} */
DR.services.struct.EveryPayData.prototype.googlePayMerchantIdentifier = null;
/** @type {String|null} */
DR.services.struct.EveryPayData.prototype.label = null;
/** @type {String|null} */
DR.services.struct.EveryPayData.prototype.mobileToken = null;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.paymentLink = null;
/** @type {Array.<DR.services.struct.EveryPayPaymentMethod>} */
DR.services.struct.EveryPayData.prototype.paymentMethods = null;
/** @type {String} */
DR.services.struct.EveryPayData.prototype.paymentReference = null;

/** @extends {DR._Base} */
DR.services.struct.EveryPayGroupedPaymentMethods = function(par){
	/** @private */
	this._t = 1388;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.card)){
		var tmp = [];
		for( var k in par.card ) tmp.push(DR._Base.cast(par.card [k]));
		this.card = tmp;
	}
	if(DR._Base.is(par.openBanking)){
		var tmp = [];
		for( var k in par.openBanking ) tmp.push(DR._Base.cast(par.openBanking [k]));
		this.openBanking = tmp;
	}
};
DR._Base._types[1388] = DR.services.struct.EveryPayGroupedPaymentMethods;
DR.services.struct.EveryPayGroupedPaymentMethods[__P] = new DR._Base;
DR.services.struct.EveryPayGroupedPaymentMethods[__P][__C] = DR.services.struct.EveryPayGroupedPaymentMethods;
/** @type {Array.<DR.services.struct.EveryPayPaymentMethod>} */
DR.services.struct.EveryPayGroupedPaymentMethods.prototype.card = null;
/** @type {Array.<DR.services.struct.EveryPayPaymentMethodsCountry>} */
DR.services.struct.EveryPayGroupedPaymentMethods.prototype.openBanking = null;

/** @extends {DR._Base} */
DR.services.struct.GetHintsPackagesRe = function(par){
	/** @private */
	this._t = 1249;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.packages)){
		var tmp = [];
		for( var k in par.packages ) tmp.push(DR._Base.cast(par.packages [k]));
		this.packages = tmp;
	}
};
DR._Base._types[1249] = DR.services.struct.GetHintsPackagesRe;
DR.services.struct.GetHintsPackagesRe[__P] = new DR._Base;
DR.services.struct.GetHintsPackagesRe[__P][__C] = DR.services.struct.GetHintsPackagesRe;
/** @type {Array.<DR.services.struct.HintPackage>} */
DR.services.struct.GetHintsPackagesRe.prototype.packages = null;

/** @extends {DR._Base} */
DR.services.struct.GetOmnivaLocationsRe = function(par){
	/** @private */
	this._t = 1148;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.locations)){
		var tmp = [];
		for( var k in par.locations ) tmp.push(DR._Base.cast(par.locations [k]));
		this.locations = tmp;
	}
};
DR._Base._types[1148] = DR.services.struct.GetOmnivaLocationsRe;
DR.services.struct.GetOmnivaLocationsRe[__P] = new DR._Base;
DR.services.struct.GetOmnivaLocationsRe[__P][__C] = DR.services.struct.GetOmnivaLocationsRe;
/** @type {Array.<DR.services.struct.OmnivaLocation>} */
DR.services.struct.GetOmnivaLocationsRe.prototype.locations = null;

/** @extends {DR._Base} */
DR.services.struct.PaymentInformationRe = function(par){
	/** @private */
	this._t = 1402;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.price)) this.price = (parseInt(par.price)||0);
};
DR._Base._types[1402] = DR.services.struct.PaymentInformationRe;
DR.services.struct.PaymentInformationRe[__P] = new DR._Base;
DR.services.struct.PaymentInformationRe[__P][__C] = DR.services.struct.PaymentInformationRe;
/** @type {Number} */
DR.services.struct.PaymentInformationRe.prototype.price = null;

/** @extends {DR._Base} */
DR.services.struct.PaymentStatus = function(par){
	/** @private */
	this._t = 1382;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.amount)) this.amount = (parseInt(par.amount)||0);
	if(DR._Base.is(par.itemCount)) this.itemCount = (parseInt(par.itemCount)||0);
	if(DR._Base.is(par.status)) this.status = String(par.status||'');
};
DR._Base._types[1382] = DR.services.struct.PaymentStatus;
DR.services.struct.PaymentStatus.STATUS_SUCCESSFUL = "successful";
DR.services.struct.PaymentStatus.STATUS_FAILED = "failed";
DR.services.struct.PaymentStatus.STATUS_PENDING = "pending";
DR.services.struct.PaymentStatus[__P] = new DR._Base;
DR.services.struct.PaymentStatus[__P][__C] = DR.services.struct.PaymentStatus;
/** @type {Number} */
DR.services.struct.PaymentStatus.prototype.amount = null;
/** @type {Number} */
DR.services.struct.PaymentStatus.prototype.itemCount = null;
/** @type {String} */
DR.services.struct.PaymentStatus.prototype.status = null;

/** @extends {DR._Base} */
DR.services.struct.GetPickupLocationsRe = function(par){
	/** @private */
	this._t = 1300;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.locations)){
		var tmp = [];
		for( var k in par.locations ) tmp.push(DR._Base.cast(par.locations [k]));
		this.locations = tmp;
	}
	if(DR._Base.is(par.selected)) this.selected = DR._Base.cast(par.selected);
};
DR._Base._types[1300] = DR.services.struct.GetPickupLocationsRe;
DR.services.struct.GetPickupLocationsRe[__P] = new DR._Base;
DR.services.struct.GetPickupLocationsRe[__P][__C] = DR.services.struct.GetPickupLocationsRe;
/** @type {Array.<DR.services.struct.PickupLocation>} */
DR.services.struct.GetPickupLocationsRe.prototype.locations = null;
/** @type {DR.services.struct.PickupLocation|null} */
DR.services.struct.GetPickupLocationsRe.prototype.selected = null;

/** @extends {DR._Base} */
DR.services.struct.PreparePurchaseStickersRe = function(par){
	/** @private */
	this._t = 1265;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.paymentInfo)) this.paymentInfo = DR._Base.cast(par.paymentInfo);
};
DR._Base._types[1265] = DR.services.struct.PreparePurchaseStickersRe;
DR.services.struct.PreparePurchaseStickersRe[__P] = new DR._Base;
DR.services.struct.PreparePurchaseStickersRe[__P][__C] = DR.services.struct.PreparePurchaseStickersRe;
/** @type {DR.services.struct.PaymentInfo} */
DR.services.struct.PreparePurchaseStickersRe.prototype.paymentInfo = null;

/** @extends {DR._Base} */
DR.services.struct.PreparePurchaseTicketRe = function(par){
	/** @private */
	this._t = 1140;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.discountCode)) this.discountCode = String(par.discountCode||'');
	if(DR._Base.is(par.donation)) this.donation = (parseInt(par.donation)||0);
	if(DR._Base.is(par.hadPreviousTeam)) this.hadPreviousTeam = Boolean(par.hadPreviousTeam);
	if(DR._Base.is(par.inviteEmails)){
		var tmp = [];
		for( var k in par.inviteEmails ) tmp.push(String(par.inviteEmails [k]||''));
		this.inviteEmails = tmp;
	}
	if(DR._Base.is(par.paymentInfo)) this.paymentInfo = DR._Base.cast(par.paymentInfo);
	if(DR._Base.is(par.playerCount)) this.playerCount = (parseInt(par.playerCount)||0);
	if(DR._Base.is(par.teamCount)) this.teamCount = (parseInt(par.teamCount)||0);
	if(DR._Base.is(par.teamTitle)) this.teamTitle = String(par.teamTitle||'');
};
DR._Base._types[1140] = DR.services.struct.PreparePurchaseTicketRe;
DR.services.struct.PreparePurchaseTicketRe[__P] = new DR._Base;
DR.services.struct.PreparePurchaseTicketRe[__P][__C] = DR.services.struct.PreparePurchaseTicketRe;
/** @type {String|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.discountCode = null;
/** @type {Number|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.donation = null;
/** @type {Boolean|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.hadPreviousTeam = null;
/** @type {Array.<String>|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.inviteEmails = null;
/** @type {DR.services.struct.PaymentInfo} */
DR.services.struct.PreparePurchaseTicketRe.prototype.paymentInfo = null;
/** @type {Number|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.playerCount = null;
/** @type {Number|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.teamCount = null;
/** @type {String|null} */
DR.services.struct.PreparePurchaseTicketRe.prototype.teamTitle = null;

/** @extends {DR._Base} */
DR.services.struct.BraintreeTransactionRe = function(par){
	/** @private */
	this._t = 1203;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.errors)){
		var tmp = [];
		for( var k in par.errors ) tmp.push(String(par.errors [k]||''));
		this.errors = tmp;
	}
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
};
DR._Base._types[1203] = DR.services.struct.BraintreeTransactionRe;
DR.services.struct.BraintreeTransactionRe[__P] = new DR._Base;
DR.services.struct.BraintreeTransactionRe[__P][__C] = DR.services.struct.BraintreeTransactionRe;
/** @type {Array.<String>} */
DR.services.struct.BraintreeTransactionRe.prototype.errors = null;
/** @type {Boolean} */
DR.services.struct.BraintreeTransactionRe.prototype.ok = null;

/** @extends {DR._Base} */
DR.services.struct.PurchaseHintsRe = function(par){
	/** @private */
	this._t = 1246;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.freePurchase)) this.freePurchase = Boolean(par.freePurchase);
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
	if(DR._Base.is(par.paymentId)) this.paymentId = (parseInt(par.paymentId)||0);
	if(DR._Base.is(par.paymentMethod)) this.paymentMethod = String(par.paymentMethod||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1246] = DR.services.struct.PurchaseHintsRe;
DR.services.struct.PurchaseHintsRe.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.struct.PurchaseHintsRe.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.struct.PurchaseHintsRe[__P] = new DR._Base;
DR.services.struct.PurchaseHintsRe[__P][__C] = DR.services.struct.PurchaseHintsRe;
/** @type {Boolean} */
DR.services.struct.PurchaseHintsRe.prototype.freePurchase = null;
/** @type {Boolean} */
DR.services.struct.PurchaseHintsRe.prototype.ok = null;
/** @type {Number} */
DR.services.struct.PurchaseHintsRe.prototype.paymentId = null;
/** @type {String} */
DR.services.struct.PurchaseHintsRe.prototype.paymentMethod = null;
/** @type {String} */
DR.services.struct.PurchaseHintsRe.prototype.url = null;

/** @extends {DR._Base} */
DR.services.struct.PurchaseTeamUsersRe = function(par){
	/** @private */
	this._t = 1266;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.freePurchase)) this.freePurchase = Boolean(par.freePurchase);
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
	if(DR._Base.is(par.paymentId)) this.paymentId = (parseInt(par.paymentId)||0);
	if(DR._Base.is(par.paymentMethod)) this.paymentMethod = String(par.paymentMethod||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1266] = DR.services.struct.PurchaseTeamUsersRe;
DR.services.struct.PurchaseTeamUsersRe.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.struct.PurchaseTeamUsersRe.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.struct.PurchaseTeamUsersRe[__P] = new DR._Base;
DR.services.struct.PurchaseTeamUsersRe[__P][__C] = DR.services.struct.PurchaseTeamUsersRe;
/** @type {Boolean} */
DR.services.struct.PurchaseTeamUsersRe.prototype.freePurchase = null;
/** @type {Boolean} */
DR.services.struct.PurchaseTeamUsersRe.prototype.ok = null;
/** @type {Number} */
DR.services.struct.PurchaseTeamUsersRe.prototype.paymentId = null;
/** @type {String} */
DR.services.struct.PurchaseTeamUsersRe.prototype.paymentMethod = null;
/** @type {String|null} */
DR.services.struct.PurchaseTeamUsersRe.prototype.url = null;

/** @extends {DR._Base} */
DR.services.struct.PurchaseTimeExtensionRe = function(par){
	/** @private */
	this._t = 1235;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.endTime)) this.endTime = (parseInt(par.endTime)||0);
	if(DR._Base.is(par.freePurchase)) this.freePurchase = Boolean(par.freePurchase);
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
	if(DR._Base.is(par.paymentId)) this.paymentId = (parseInt(par.paymentId)||0);
	if(DR._Base.is(par.paymentMethod)) this.paymentMethod = String(par.paymentMethod||'');
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1235] = DR.services.struct.PurchaseTimeExtensionRe;
DR.services.struct.PurchaseTimeExtensionRe.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.struct.PurchaseTimeExtensionRe.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.struct.PurchaseTimeExtensionRe[__P] = new DR._Base;
DR.services.struct.PurchaseTimeExtensionRe[__P][__C] = DR.services.struct.PurchaseTimeExtensionRe;
/** @type {Number|null} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.endTime = null;
/** @type {Boolean} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.freePurchase = null;
/** @type {Boolean} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.ok = null;
/** @type {Number} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.paymentId = null;
/** @type {String} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.paymentMethod = null;
/** @type {String} */
DR.services.struct.PurchaseTimeExtensionRe.prototype.url = null;

/** @extends {DR._Method} */
DR.services.CheckDiscount = function(par){
	this.select = [];
	/** @private */
	this._t = 1134;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1134] = DR.services.CheckDiscount;
DR.services.CheckDiscount[__CL] = "Services__CheckDiscount";
DR.services.CheckDiscount[__P] = new DR._Method;
DR.services.CheckDiscount[__P][__C] = DR.services.CheckDiscount;
/** @type {String|null} */
DR.services.CheckDiscount.prototype.code = null;
/** @type {Number|null} */
DR.services.CheckDiscount.prototype.donation = null;
/** @type {DR.services.struct.CheckDiscountRe} */
DR.services.CheckDiscount.prototype.re = null;

/** @extends {DR._Method} */
DR.services.CheckPurchaseTicket = function(par){
	this.select = [];
	/** @private */
	this._t = 1151;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1151] = DR.services.CheckPurchaseTicket;
DR.services.CheckPurchaseTicket[__CL] = "Services__CheckPurchaseTicket";
DR.services.CheckPurchaseTicket[__P] = new DR._Method;
DR.services.CheckPurchaseTicket[__P][__C] = DR.services.CheckPurchaseTicket;
/** @type {String|null} */
DR.services.CheckPurchaseTicket.prototype.discountCode = null;
/** @type {Number|null} */
DR.services.CheckPurchaseTicket.prototype.donation = null;
/** @type {Array.<String>|null} */
DR.services.CheckPurchaseTicket.prototype.inviteEmails = null;
/** @type {DR.services.struct.PaymentInfo|null} */
DR.services.CheckPurchaseTicket.prototype.paymentInfo = null;
/** @type {String|null} */
DR.services.CheckPurchaseTicket.prototype.teamTitle = null;
/** @type {DR.services.struct.PurchaseTicketRe} */
DR.services.CheckPurchaseTicket.prototype.re = null;

/** @extends {DR._Method} */
DR.services.CheckVAT = function(par){
	this.select = [];
	/** @private */
	this._t = 1293;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1293] = DR.services.CheckVAT;
DR.services.CheckVAT[__CL] = "Services__CheckVAT";
DR.services.CheckVAT.TYPE_PRIVATE = "private";
DR.services.CheckVAT.TYPE_COMPANY = "company";
DR.services.CheckVAT[__P] = new DR._Method;
DR.services.CheckVAT[__P][__C] = DR.services.CheckVAT;
/** @type {String} */
DR.services.CheckVAT.prototype.country = null;
/** @type {String} */
DR.services.CheckVAT.prototype.type = null;
/** @type {String|null} */
DR.services.CheckVAT.prototype.vatNumber = null;
/** @type {DR.services.struct.VATStatus} */
DR.services.CheckVAT.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetBraintreeClientToken = function(par){
	this.select = [];
	/** @private */
	this._t = 1202;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1202] = DR.services.GetBraintreeClientToken;
DR.services.GetBraintreeClientToken[__CL] = "Services__GetBraintreeClientToken";
DR.services.GetBraintreeClientToken[__P] = new DR._Method;
DR.services.GetBraintreeClientToken[__P][__C] = DR.services.GetBraintreeClientToken;
/** @type {DR.services.struct.BraintreeClientToken} */
DR.services.GetBraintreeClientToken.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetEveryPayData = function(par){
	this.select = [];
	/** @private */
	this._t = 1385;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1385] = DR.services.GetEveryPayData;
DR.services.GetEveryPayData[__CL] = "Services__GetEveryPayData";
DR.services.GetEveryPayData[__P] = new DR._Method;
DR.services.GetEveryPayData[__P][__C] = DR.services.GetEveryPayData;
/** @type {Boolean|null} */
DR.services.GetEveryPayData.prototype.isWebview = null;
/** @type {Number} */
DR.services.GetEveryPayData.prototype.paymentId = null;
/** @type {String|null} */
DR.services.GetEveryPayData.prototype.selectedPaymentMethod = null;
/** @type {DR.services.struct.EveryPayData} */
DR.services.GetEveryPayData.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetEveryPayPaymentMethods = function(par){
	this.select = [];
	/** @private */
	this._t = 1389;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1389] = DR.services.GetEveryPayPaymentMethods;
DR.services.GetEveryPayPaymentMethods[__CL] = "Services__GetEveryPayPaymentMethods";
DR.services.GetEveryPayPaymentMethods[__P] = new DR._Method;
DR.services.GetEveryPayPaymentMethods[__P][__C] = DR.services.GetEveryPayPaymentMethods;
/** @type {DR.services.struct.EveryPayGroupedPaymentMethods} */
DR.services.GetEveryPayPaymentMethods.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetHintPackages = function(par){
	this.select = [];
	/** @private */
	this._t = 1250;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1250] = DR.services.GetHintPackages;
DR.services.GetHintPackages[__CL] = "Services__GetHintPackages";
DR.services.GetHintPackages[__P] = new DR._Method;
DR.services.GetHintPackages[__P][__C] = DR.services.GetHintPackages;
/** @type {DR.services.struct.GetHintsPackagesRe} */
DR.services.GetHintPackages.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetOmnivaLocations = function(par){
	this.select = [];
	/** @private */
	this._t = 1149;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1149] = DR.services.GetOmnivaLocations;
DR.services.GetOmnivaLocations[__CL] = "Services__GetOmnivaLocations";
DR.services.GetOmnivaLocations[__P] = new DR._Method;
DR.services.GetOmnivaLocations[__P][__C] = DR.services.GetOmnivaLocations;
/** @type {DR.services.struct.GetOmnivaLocationsRe} */
DR.services.GetOmnivaLocations.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetPaymentInformation = function(par){
	this.select = [];
	/** @private */
	this._t = 1403;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1403] = DR.services.GetPaymentInformation;
DR.services.GetPaymentInformation[__CL] = "Services__GetPaymentInformation";
DR.services.GetPaymentInformation[__P] = new DR._Method;
DR.services.GetPaymentInformation[__P][__C] = DR.services.GetPaymentInformation;
/** @type {Number} */
DR.services.GetPaymentInformation.prototype.paymentId = null;
/** @type {DR.services.struct.PaymentInformationRe} */
DR.services.GetPaymentInformation.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetPaymentStatus = function(par){
	this.select = [];
	/** @private */
	this._t = 1383;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1383] = DR.services.GetPaymentStatus;
DR.services.GetPaymentStatus[__CL] = "Services__GetPaymentStatus";
DR.services.GetPaymentStatus[__P] = new DR._Method;
DR.services.GetPaymentStatus[__P][__C] = DR.services.GetPaymentStatus;
/** @type {Number} */
DR.services.GetPaymentStatus.prototype.paymentId = null;
/** @type {DR.services.struct.PaymentStatus} */
DR.services.GetPaymentStatus.prototype.re = null;

/** @extends {DR._Method} */
DR.services.GetPickupLocations = function(par){
	this.select = [];
	/** @private */
	this._t = 1301;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1301] = DR.services.GetPickupLocations;
DR.services.GetPickupLocations[__CL] = "Services__GetPickupLocations";
DR.services.GetPickupLocations[__P] = new DR._Method;
DR.services.GetPickupLocations[__P][__C] = DR.services.GetPickupLocations;
/** @type {DR.services.struct.GetPickupLocationsRe} */
DR.services.GetPickupLocations.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PreparePurchaseStickers = function(par){
	this.select = [];
	/** @private */
	this._t = 1264;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1264] = DR.services.PreparePurchaseStickers;
DR.services.PreparePurchaseStickers[__CL] = "Services__PreparePurchaseStickers";
DR.services.PreparePurchaseStickers[__P] = new DR._Method;
DR.services.PreparePurchaseStickers[__P][__C] = DR.services.PreparePurchaseStickers;
/** @type {DR.services.struct.PreparePurchaseStickersRe} */
DR.services.PreparePurchaseStickers.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PreparePurchaseTicket = function(par){
	this.select = [];
	/** @private */
	this._t = 1143;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1143] = DR.services.PreparePurchaseTicket;
DR.services.PreparePurchaseTicket[__CL] = "Services__PreparePurchaseTicket";
DR.services.PreparePurchaseTicket[__P] = new DR._Method;
DR.services.PreparePurchaseTicket[__P][__C] = DR.services.PreparePurchaseTicket;
/** @type {DR.services.struct.PreparePurchaseTicketRe} */
DR.services.PreparePurchaseTicket.prototype.re = null;

/** @extends {DR._Method} */
DR.services.ProcessBraintreeTransaction = function(par){
	this.select = [];
	/** @private */
	this._t = 1204;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1204] = DR.services.ProcessBraintreeTransaction;
DR.services.ProcessBraintreeTransaction[__CL] = "Services__ProcessBraintreeTransaction";
DR.services.ProcessBraintreeTransaction[__P] = new DR._Method;
DR.services.ProcessBraintreeTransaction[__P][__C] = DR.services.ProcessBraintreeTransaction;
/** @type {String} */
DR.services.ProcessBraintreeTransaction.prototype.nonce = null;
/** @type {Number} */
DR.services.ProcessBraintreeTransaction.prototype.paymentId = null;
/** @type {DR.services.struct.BraintreeTransactionRe} */
DR.services.ProcessBraintreeTransaction.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PurchaseHints = function(par){
	this.select = [];
	/** @private */
	this._t = 1247;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1247] = DR.services.PurchaseHints;
DR.services.PurchaseHints[__CL] = "Services__PurchaseHints";
DR.services.PurchaseHints.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.PurchaseHints.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.PurchaseHints[__P] = new DR._Method;
DR.services.PurchaseHints[__P][__C] = DR.services.PurchaseHints;
/** @type {Number} */
DR.services.PurchaseHints.prototype.count = null;
/** @type {String} */
DR.services.PurchaseHints.prototype.paymentMethod = null;
/** @type {DR.services.struct.PurchaseHintsRe} */
DR.services.PurchaseHints.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PurchaseTeamUsers = function(par){
	this.select = [];
	/** @private */
	this._t = 1267;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1267] = DR.services.PurchaseTeamUsers;
DR.services.PurchaseTeamUsers[__CL] = "Services__PurchaseTeamUsers";
DR.services.PurchaseTeamUsers.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.PurchaseTeamUsers.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.PurchaseTeamUsers[__P] = new DR._Method;
DR.services.PurchaseTeamUsers[__P][__C] = DR.services.PurchaseTeamUsers;
/** @type {String} */
DR.services.PurchaseTeamUsers.prototype.paymentMethod = null;
/** @type {Number} */
DR.services.PurchaseTeamUsers.prototype.playerCount = null;
/** @type {DR.services.struct.PurchaseTeamUsersRe} */
DR.services.PurchaseTeamUsers.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PurchaseTicket = function(par){
	this.select = [];
	/** @private */
	this._t = 1131;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1131] = DR.services.PurchaseTicket;
DR.services.PurchaseTicket[__CL] = "Services__PurchaseTicket";
DR.services.PurchaseTicket.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.PurchaseTicket.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.PurchaseTicket[__P] = new DR._Method;
DR.services.PurchaseTicket[__P][__C] = DR.services.PurchaseTicket;
/** @type {String|null} */
DR.services.PurchaseTicket.prototype.discountCode = null;
/** @type {Number|null} */
DR.services.PurchaseTicket.prototype.donation = null;
/** @type {Array.<String>|null} */
DR.services.PurchaseTicket.prototype.inviteEmails = null;
/** @type {DR.services.struct.PaymentInfo} */
DR.services.PurchaseTicket.prototype.paymentInfo = null;
/** @type {String|null} */
DR.services.PurchaseTicket.prototype.paymentMethod = null;
/** @type {Number|null} */
DR.services.PurchaseTicket.prototype.playerCount = null;
/** @type {Number|null} */
DR.services.PurchaseTicket.prototype.teamCount = null;
/** @type {String|null} */
DR.services.PurchaseTicket.prototype.teamTitle = null;
/** @type {Boolean|null} */
DR.services.PurchaseTicket.prototype.useAffiliateDiscount = null;
/** @type {Boolean|null} */
DR.services.PurchaseTicket.prototype.useFirstAffiliateDiscount = null;
/** @type {DR.services.struct.PurchaseTicketRe} */
DR.services.PurchaseTicket.prototype.re = null;

/** @extends {DR._Method} */
DR.services.PurchaseTimeExtension = function(par){
	this.select = [];
	/** @private */
	this._t = 1236;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1236] = DR.services.PurchaseTimeExtension;
DR.services.PurchaseTimeExtension[__CL] = "Services__PurchaseTimeExtension";
DR.services.PurchaseTimeExtension.PAYMENTMETHOD_BRAINTREE = "braintree";
DR.services.PurchaseTimeExtension.PAYMENTMETHOD_EVERYPAY = "every-pay";
DR.services.PurchaseTimeExtension[__P] = new DR._Method;
DR.services.PurchaseTimeExtension[__P][__C] = DR.services.PurchaseTimeExtension;
/** @type {String} */
DR.services.PurchaseTimeExtension.prototype.paymentMethod = null;
/** @type {DR.services.struct.PurchaseTimeExtensionRe} */
DR.services.PurchaseTimeExtension.prototype.re = null;

D.loaded();